import React from 'react';
import { Radio, RadioGroup } from '@mui/material';
import LogoSvg from '../svg/logo.svg';

const PayseraMark = () => (
    <svg className="payment-method-card__wallet-mark" viewBox="0 0 102 130" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Paysera">
        <path d="M22.3631 50.6808H0V129.985H22.3631V50.6808Z" fill="#33CC66" />
        <path d="M79.3 50.6808C79.3455 58.2014 76.3789 65.4339 71.0487 70.7975C65.7185 76.1611 58.4582 79.2196 50.8548 79.3044C37.328 79.3934 24.3866 84.7737 14.8578 94.2698C5.32904 103.766 -0.0125446 116.606 2.21234e-05 129.985H22.3631C22.3299 122.463 25.3047 115.233 30.6389 109.871C35.9732 104.509 43.2343 101.45 50.8393 101.361C64.3645 101.276 77.3051 95.8964 86.8298 86.3986C96.3546 76.9007 101.688 64.0582 101.663 50.6808H79.3Z" fill="#000099" />
        <path d="M50.8395 0C37.3156 0.0889973 24.3773 5.4702 14.8535 14.9672C5.32965 24.4643 -0.00506811 37.3044 0.0156853 50.6805H22.3633C22.322 43.1586 25.292 35.9261 30.6246 30.5629C35.9573 25.1998 43.2192 22.1418 50.824 22.057C58.4302 22.1378 65.6944 25.1945 71.0279 30.5585C76.3615 35.9226 79.3302 43.1574 79.2848 50.6805H101.648C101.673 37.3058 96.3414 24.4656 86.8201 14.9682C77.2987 5.47070 64.362 0.0889982 50.8395 0Z" fill="#3399FF" />
    </svg>
);

const CardIcon = () => (
    <svg className="payment-method-card__card-icon" width="36" height="28" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="1" y="1" width="30" height="22" rx="4" stroke="#000099" strokeWidth="1.5" />
        <path d="M1 8H31" stroke="#000099" strokeWidth="1.5" />
        <rect x="5" y="14" width="10" height="2.5" rx="1.25" fill="#000099" />
    </svg>
);

const PaymentMethodSelector = ({
    paymentMethodCode,
    onPaymentMethodChange,
    onPaymentMethodClick,
}) => {
    const renderOption = (value, icon, content) => (
        <div
            className={`payment-method-card paysera-card-surface${paymentMethodCode === value ? ' payment-method-card--selected' : ''}`}
            onClick={() => onPaymentMethodClick(value)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    onPaymentMethodClick(value);
                }
            }}
        >
            <Radio
                checked={paymentMethodCode === value}
                onChange={onPaymentMethodChange}
                value={value}
                name="payment-method"
                inputProps={{ 'aria-label': value }}
            />
            {icon ? <div className="payment-method-card__icon">{icon}</div> : null}
            <div className="payment-method-card__content">{content}</div>
        </div>
    );

    return (
        <div className="paysera-paymentMethod">
            <RadioGroup
                aria-labelledby="payment-method-group"
                name="payment-method-group"
                value={paymentMethodCode}
            >
                {renderOption(
                    'wallet',
                    <PayseraMark />,
                    <>
                        <div className="payment-method-card__title body-font">Pagesë e shpejtë dhe e sigurt</div>
                        <div className="payment-method-card__partner-logos">
                            <img src={LogoSvg} alt="Paysera" />
                            <img src="/components/footer/additional-payment-1.svg" alt="Revolut" />
                            <img src="/components/footer/additional-payment-2.svg" alt="Wise" />
                            <img src="/components/footer/additional-payment-3.svg" alt="bunq" />
                        </div>
                    </>,
                )}
                {renderOption(
                    'visa',
                    <CardIcon />,
                    <>
                        <div className="payment-method-card__title body-font">Pagesat me kartela</div>
                        <div className="payment-method-card__card-logos">
                            <img src="/components/footer/Visa_Brandmark_Blue_RGB_2021.png" alt="VISA" />
                            <img src="/components/footer/Mastercard-logo.svg.png" alt="Mastercard" />
                            <img src="/components/footer/Maestro_logo.png" alt="Maestro" />
                            <span className="payment-method-card__wallet-badge">
                                <img src="/components/footer/Apple_Pay_Acceptance_Mark.svg" alt="Apple Pay" />
                            </span>
                            <span className="payment-method-card__wallet-badge">
                                <img src="/components/footer/GPay_Acceptance_Mark_800.png" alt="Google Pay" />
                            </span>
                        </div>
                    </>,
                )}
                {renderOption(
                    'PaySeraKredi',
                    <img src="/components/footer/finmo-icon.png" alt="" className="payment-method-card__finmo-mark" />,
                    <>
                        <div className="payment-method-card__title body-font">Paguaj përmes kredisë Finmo</div>
                        <div className="payment-method-card__subtitle body-font">
                            Kredi e shpejtë deri në <strong>3,000€</strong>
                        </div>
                    </>,
                )}
            </RadioGroup>
        </div>
    );
};

export default PaymentMethodSelector;
